import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormInput } from 'components/AntEnhancement/FormControls';
import localeTranslator from 'library/Hocs/LocalTranslator';
import './style.css';
var ProductCategoryForm = function (props) {
    var t = props.translate;
    var onChangeName = function (event) {
        props.productCategory.setName(event.target.value);
    };
    return (_jsx("div", { className: "pcat-form", children: _jsxs("div", { className: "pcat-form__field", children: [_jsxs("label", { className: "pcat-form__label", htmlFor: "name", children: [t('name'), " ", _jsx("span", { className: "pcat-form__req", children: "*" })] }), _jsx(FormInput, { label: t('name'), name: "name", placeHolder: t('namePlaceholder'), rules: [{ required: true, message: t('errors.name') }], onChange: onChangeName, initialValue: props.productCategory.getName() })] }) }));
};
export default localeTranslator(ProductCategoryForm, 'productCategoryForm');
